import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';

import { set404 } from '../actions/App';

class NoMatch extends Component {
  componentDidMount() {
    const { set404Action } = this.props;
    set404Action(true);
  }

  componentWillUnmount() {
    const { set404Action } = this.props;
    set404Action(false);
  }

  render() {
    const { intl } = this.props;
    return (
      <div className="nothing-found-wrapper">
        <h3>{intl.formatMessage({ defaultMessage: 'Page not found' })}</h3>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  set404Action: (status) => {
    dispatch(set404(status));
  },
});

NoMatch.propTypes = {
  intl: PropTypes.object.isRequired,
  set404Action: PropTypes.func.isRequired,
};

export default injectIntl(connect(null, mapDispatchToProps)(NoMatch));
